import { Injectable } from '@angular/core';
import { AppService } from '../shared/service/AppService.class';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

const EP = environment.reports_endpoints;

@Injectable({
  providedIn: 'root'
})
export class ReportsService extends AppService<any> {
  public reportdata: BehaviorSubject<any>=new BehaviorSubject<any>({});
  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "report";
   }

   senddata(data: any) {
    this.reportdata.next(data);
  }

   public getReportsData(data: any) {
    let tmp = this.appmod;
    this.appmod = EP.all_reports;
    let result = super.saveService(data);
    this.appmod = tmp;
    return result;
   }

   getAgentsReportsData(data: any) {
    let tmp = this.appmod;
    this.appmod = EP.agent_reports;
    let result = super.saveService(data);
    this.appmod = tmp;
    return result;
   }

   getCallTerminationReportsData(data: any) {
    let tmp = this.appmod;
    this.appmod = EP.call_termination_reports;
    let result = super.saveService(data);
    this.appmod = tmp;
    return result;
   }

   getCallCenterReportsData(data: any) {
    let tmp = this.appmod;
    this.appmod = EP.call_center_reports;
    let result = super.saveService(data);
    this.appmod = tmp;
    return result;
   }

   getSkillGroupReportsData(data: any) {
    let tmp = this.appmod;
    this.appmod = EP.skill_group_reports;
    let result = super.saveService(data);
    this.appmod = tmp;
    return result;
   }

   getivrReportsData(data: any) {
    let tmp = this.appmod;
    this.appmod = EP.ivr_reports;
    let result = super.saveService(data);
    this.appmod = tmp;
    return result;
   }

  getLiveCallsData(data: any) {
    let tmp = this.appmod;
    this.appmod = EP.live_reports;
    let result = super.saveService(data);
    this.appmod = tmp;
    return result;
  }

  getAgentGroupList() {
    let tmp = this.appmod;
    this.appmod = EP.agent_group_list;
    let result = super.getOption('main');
    this.appmod = tmp;
    return result;
  }

  getdata(api: any) {
    this.appmod = EP.report_options;
    let result = super.getOption(api);
    this.appmod = "report";
    return result;
  }


  loadConfig(): Observable<any> {
    return new Observable((observer) => {
      fetch('/assets/jsondata/reports.json')
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            throw new Error('Failed to load JSON file');
          }
        })
        .then((data) => {
          observer.next(data);
          observer.complete();
        })
        .catch((error) => {
          console.error(error);
          observer.error(error);
        });
    });
  }

}